<template>
  <div class="">
    <nav class="navbar navbar-lg navbar-expand-lg navbar-dark bg-primary">
      <div class="container-fluid">
        <router-link class="navbar-brand" to="/user/landing">
          Scales
        </router-link>
        <div class="dropdown">
          <button class="btn btn-outline-white dropdown-toggle mr-2" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{$t('navbar.language')}}
          </button>
          <div class="dropdown-menu">
            <button class="dropdown-item" @click="changeLanguage('en')">
              {{$t('languageChoice.English')}}
            </button>
            <button class="dropdown-item" @click="changeLanguage('zh')">
              {{$t('languageChoice.Chinese')}}
            </button>
            <button class="dropdown-item" @click="changeLanguage('jp')">
              {{$t('languageChoice.Japanese')}}
            </button>
          </div>
        </div>
      </div>
    </nav>
    <main class="main" role="main">
      <div class="py-5 bg-light">
        <div class="container">
          <div class="col-md-12 p-0">
            <div class="card mt-4 pt-3 pb-3">
              <div class="card-body">
                <form label-width="0px" class="demo-ruleForm needs-validation-update-password" novalidate>
                  <div class="text-center pt-3 pb-3">
                    {{$t('UpdatePasswordPage.Tips')}}
                  </div>
                  <div class="form-group row no-gutters col-12 pb-3">
                    <label class="col-12 col-md-3 offset-md-1" for="email">{{$t('login.email')}}</label>
                    <div class="col-12 col-md-8">
                      <input class="form-control" readonly :value="email" id="email">
                    </div>
                  </div>
                  <div class="form-group row no-gutters col-12 pb-3">
                    <label class="col-12 col-md-3 offset-md-1" for="newPassword">{{$t('UpdatePasswordPage.NewsPassword')}}</label>
                    <div class="col-12 col-md-8">
                      <input type="password" maxlength="128" class="form-control" required v-model="newPassword" id="newPassword">
                      <div class="invalid-feedback">
                        {{$t('UpdatePasswordPage.ErrorPormptnewspad')}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row no-gutters col-12 mb-0">
                    <label class="col-12 col-md-3 offset-md-1" for="verifyPassword">{{$t('UpdatePasswordPage.VerifyPassword')}}</label>
                    <div class="col-12 col-md-8">
                      <input type="password" maxlength="128" class="form-control" required v-model="verifyPassword" id="verifyPassword">
                      <div class="invalid-feedback">
                        {{$t('UpdatePasswordPage.ErrorPormptVerify')}}
                      </div>
                      <div class="invalid-feedback password-not-match" style="display:none">
                        {{$t('UpdatePasswordPage.notMatch')}}
                      </div>
                    </div>
                  </div>
                  <div class="row justify-content-end mt-4 col-12 pr-0">
                    <div class="col-6 text-right pr-0">
                      <button class="btn btn-primary" @click="update" :disabled="email === null || email === ''">{{$t('UpdatePasswordPage.Changebtn')}}</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <copyright></copyright>
  </div>
</template>
<style src="../../../static/css/dashboard.css" />

<script type="text/javascript">
import { NmsClient, RestCfg, Env } from '../../scripts/AllExport'
import copyright from '../user/copyright'
import Cookies from 'js-cookie'
import crypto from 'crypto'
let forgetPasswordCheckReqType = 'user-forget-password-check'
let forgetPasswordUpdateReqType = 'user-forget-password-update'
export default {
  components: { copyright },
  data: function () {
    return {
      email: '',
      newPassword: '',
      verifyPassword: ''
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      NmsClient.send(
        RestCfg.POST,
        {
          'reqType': forgetPasswordCheckReqType,
          'id': this.$route.query.id,
          'token': this.$route.query.token,
          'type': 2
        },
        this.forgetPasswordCheckResult,
        null
      )
    },
    forgetPasswordCheckResult(response) {
      this.email = response.resultInfo.operatorEmail
    },
    update() {
      let form = $('.needs-validation-update-password')[0]

      form.onsubmit = (event) => {
        event.preventDefault()
        if (this.checkpass(form) && form.checkValidity()) {
          NmsClient.send(
            RestCfg.POST,
            {
              'reqType': forgetPasswordUpdateReqType,
              'newPassword': this.createHash(this.verifyPassword),
              'id': this.$route.query.id,
              'token': this.$route.query.token,
              'type': 2
            },
            () => {
              this.$alert(this.$t('forgotPassword.passwordChangeSuccess'), this.$t('forgotPassword.message'), {
                confirmButtonText: 'OK',
                lockScroll: false,
                closeOnClickModal: true,
                callback: action => {
                  this.$router.push({path: 'login'})
                }
              })
            },
            null
          )
        }
        form.classList.add('was-validated')
      }
    },
    changeLanguage(language) {
      let setLanguage = language
      Cookies.set('language', setLanguage, { path: '/', expires: Env.COOKIES_TTL })
      this.$i18n.locale = setLanguage
    },
    createHash(password) {
      // パスワードハッシュ化
      let md5 = crypto.createHash('md5')
      let md5Sum = md5.update(password)
      return md5Sum.digest('Base64')
    },
    checkpass(from) {
      let jqCheckPassword = $('#verifyPassword')
      $('#verifyPassword,#newPassword').off('input propertychange').on('input propertychange', () => {
        if (this.newPassword !== this.verifyPassword) {
          jqCheckPassword.removeClass('password-valid').addClass('password-invalid')
          if (this.verifyPassword === '') {
            jqCheckPassword.parent().find('.password-not-match').css({'display': 'none'})
            return
          }
          jqCheckPassword.parent().find('.password-not-match').css({'display': 'block'})
        } else {
          jqCheckPassword.parent().find('.password-not-match').css({'display': 'none'})
          if (this.verifyPassword === null || this.verifyPassword === '') return
          jqCheckPassword.removeClass('password-invalid').addClass('password-valid')
        }
      })
      if (!from.checkValidity()) {
        return
      }
      if (this.newPassword !== this.verifyPassword) {
        jqCheckPassword.removeClass('password-valid').addClass('password-invalid')
        jqCheckPassword.parent().find('.password-not-match').css({'display': 'block'})
        return false
      } else {
        jqCheckPassword.removeClass('password-invalid').addClass('password-valid')
        return true
      }
    }
  }
}
</script>
<style scoped>
.navbar {
  font-weight: normal;
}
.navbar-brand button{
  background-color: white;
}
.navbar-brand {
  font-size: 1.25rem;
}
.container{
  min-height:calc(100vh - 278px)
}
.privacyPolicy-scroll-bar{
    overflow: auto;
    height: 420px;
}
.form-group {
    margin-bottom: 1rem;
    height: 85px;
}
</style>



// WEBPACK FOOTER //
// src/components/operator/forget-password.vue